import { Button } from "react-admin";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { StyledButton } from "../../../components/ListShowButton";
import { useField } from "react-final-form";
import { find, findIndex } from "lodash";
import Alert from "@material-ui/lab/Alert";
import { AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

interface RemoveStudentButtonProps {
  studentId: number;
}

const RemoveStudentButton: React.FC<RemoveStudentButtonProps> = ({
  studentId,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [selectedStudent, setSelectedStudent] = useState<any>(null);

  const studentsField = useField("students");
  const routesField = useField("routes");
  const formStudentsChangedField = useField("formStudentsChanged");

  const classes = useStyles();

  const handleOpenDialog = () => {
    const findStudent = find(studentsField.input.value, ["id", studentId]);
    setSelectedStudent(findStudent);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSaveRemoveStudent = () => {
    const findStudentIndex = findIndex(studentsField.input.value, [
      "id",
      studentId,
    ]);

    studentsField.input.onChange([
      ...studentsField.input.value.slice(0, findStudentIndex),
      ...studentsField.input.value.slice(findStudentIndex + 1),
    ]);
    formStudentsChangedField.input.onChange(true);

    handleClose();
  };

  return (
    <>
      <StyledButton variant="outlined" onClick={handleOpenDialog}>
        Remove
      </StyledButton>

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Remove Student {selectedStudent?.firstName}{" "}
          {selectedStudent?.lastName}
        </DialogTitle>
        <DialogContent>
          {routesField.input.value.length > 0 && (
            <Alert severity="warning" style={{ marginBottom: "14px" }}>
              <AlertTitle>Warning</AlertTitle>

              <Typography variant="body2">
                Please be advised that any changes to the student list or
                address will reset all existing route data.
              </Typography>
            </Alert>
          )}

          <DialogContentText color="initial">
            Are you sure you want to remove this student?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <Button
            onClick={handleSaveRemoveStudent}
            color="primary"
            label="Save"
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RemoveStudentButton;
